import { StyledDataGrid } from "../utils/StyledDataGrid";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useEffect } from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useDispatch, useSelector } from "react-redux";

import CalculateIcon from "@mui/icons-material/Calculate";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import theme from "../theme";

const HcaConsumtionsTable = () => {
  const { t } = useTranslation();
  const consumptions = useSelector((state) => state?.meterSlice?.consumptions);
  const allocatorConsum =
    consumptions &&
    consumptions?.reduce((acc, curr) => {
      const existingEntryIndex = acc.findIndex(
        (entry) => entry.date === curr.date
      );
      if (existingEntryIndex !== -1) {
        if (curr.consumption_type === "unconverted_value") {
          acc[existingEntryIndex].unconverted_value = curr.value;
        } else if (curr.consumption_type === "converted_value") {
          acc[existingEntryIndex].converted_value = curr.value;
        }
      } else {
        const newObj = {
          ...curr,
          unconverted_value:
            curr.consumption_type === "unconverted_value"
              ? curr.value
              : undefined,
          converted_value:
            curr.consumption_type === "converted_value"
              ? curr.value
              : undefined,
        };
        acc.push(newObj);
      }
      return acc;
    }, []);

  useEffect(() => {
    console.log("allocatorConsum", allocatorConsum);
  }, [allocatorConsum]);

  const rows = allocatorConsum?.map((item, i) => ({
    id: i,
    date: t("date_val", { val: new Date(item?.date) }),
    type: item.type,
    converted_value:
      item?.converted_value !== null ? item.converted_value?.toFixed(0) : "--",
    unconverted_value:
      item?.unconverted_value !== null
        ? item.unconverted_value?.toFixed(0)
        : "--",
  }));

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      sortable: false,
      flex: 1,
      hide: true,
      headerAlign: "left",
    },

    {
      field: "date",
      headerName: t("consum_date"),
      type: "string",
      editable: false,
      flex: 3,
    },

    {
      field: "type",
      headerName: t("type"),
      type: "number",
      headerAlign: "left",
      editable: false,
      flex: 2,
      renderCell: (params) => {
        if (params.value == 1) {
          return (
            <Tooltip title={t("simulated")}>
              <CalculateIcon sx={{ fill: "green" }} />
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title={t("calculated")}>
              <OnlinePredictionIcon sx={{ fill: "#8884d8" }} />
            </Tooltip>
          );
        }
      },
    },
    {
      field: "converted_value",
      headerName: t("converted_value"),
      type: "number",
      headerAlign: "left",
      editable: false,
      flex: 2,
    },
    {
      field: "unconverted_value",
      headerName: t("unconverted_value"),
      type: "number",
      headerAlign: "left",
      editable: false,
      flex: 2,
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, width: "98%", mt: 2, height: "80%" }}>
      <Typography
        sx={{ mb: 1 }}
        color={theme.palette.primary.main}
        variant="h6"
      >
        {t("consumptions")}
      </Typography>
      <StyledDataGrid
        disableColumnMenu
        rows={rows ?? []}
        columns={columns}
        /*      rowCount={consumptions?.length} */

        disableSelectionOnClick
        // loading={isLoadingTable}
        paginationMode="client"
        getRowHeight={() => "auto"}
      />
    </Box>
  );
};

export default HcaConsumtionsTable;
